const Starter_Reservation = (props) => {
  return (
    <ul>
      <p>This is FB starter reservation section - online reservation</p>
      <li>• easy follow up reservations</li>
      <li>• reservations made by number of ppl, time, table, and custom request by approval.</li>
    </ul>
  );
}
export default Starter_Reservation;